export const getTaskBoard = '/board';
export const addTaskBoard = '/board';
export const getBoardDetails = '/board/details/';
export const addList = '/list';
export const addCard = '/card';
export const updateList = 'list/';
export const uploadDocuments = '/attachment/upload';
export const addDate = '/date';
export const getCardDetail = '/card/card-detail/';
export const moveCard = '/card/';
export const updateCardTitle = '/card/';
export const addCardMember = '/card-member';
export const addCoverImage = '/attachment/';
export const deleteCard = '/card/';
export const deleteDate = '/date/';
export const deleteList = '/list/';
export const searchMember = '/board-member/search/';
export const searchBoard = '/board/search/';
export const deleteAttachment = '/attachment/';
export const getBackground = '/board-images';
export const updateBoard = '/board/';
export const addMember = '/board-member';
export const deleteMember = '/board-member/';
export const updateDate = '/date/';
export const deleteMemberFromCard = '/card-member/';
export const updateMember = '/board-member/update/';
export const addLabel = '/label';
export const deleteLabel = '/label/';
export const updateLabel = '/label/';
export const getLabels = '/label/board/all/';
export const toggleLabel = 'label/addLabelToCard/';
export const getComments = '/comment/';
export const addComment = '/comment';
export const deleteComment = '/comment/';
export const updateComment = '/comment/';
export const replyComment = '/comment/reply/';
export const addCheckList = '/checklist';
export const deleteCheckList = '/checklist/';
export const getCheckList = '/checklist/';
export const updateCheckList = '/checklist/';
export const addCheckListItem = '/checklistItem/create-item/';
export const getCheckListItem = '/checklistItem/get-item/';
export const updateItemStatus = '/checklistItem/update-item/';
export const deleteCheckListItem = '/checklistItem/delete-item';
export const getTransaction = '/transaction/';
export const addReaction = '/reaction/toggle/';
